// @flow
export { default } from './PostHead';



// WEBPACK FOOTER //
// ./src/components/post/PostHead/index.js